"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BetLimit = void 0;
/**
 * BetLimit.ts
 *
 * Enumeration of all the possible bet limits that a game can have.
 */
var BetLimit;
(function (BetLimit) {
    /** any player can bet all the money they have (no restrictions) */
    BetLimit[BetLimit["NO_LIMIT"] = 1] = "NO_LIMIT";
    /** the size of the pot is the limit */
    BetLimit[BetLimit["POT_LIMIT"] = 2] = "POT_LIMIT";
    /** predefined amount up to which the players can bet each turn */
    BetLimit[BetLimit["FIXED_LIMIT"] = 3] = "FIXED_LIMIT";
    /** the maximum amount of money a single player can be bet per game */
    BetLimit[BetLimit["CAP_LIMIT"] = 4] = "CAP_LIMIT";
    /** provides a range from min to max money a player can bet */
    BetLimit[BetLimit["SPREAD_LIMIT"] = 5] = "SPREAD_LIMIT";
})(BetLimit || (exports.BetLimit = BetLimit = {}));
//# sourceMappingURL=BetLimit.js.map